import { useQuery, useReactiveVar } from '@apollo/client'
import { GET_ME } from 'api/auth/me'
import { isPrivyExchangingVar } from 'features/auth-privy/store'
import { useEnsureGuestSession } from '../hooks/use-ensure-guest-session'

/**
 * Gives every anonymous visitor a guest session (FE-321): the backend ignores
 * analytics without a user or guest session. Mounted once at the app root.
 *
 * Anonymous means `me` answered without a user and no Privy sign-in is being
 * exchanged for the XYRO session. NOTE: its own `me` query, not `useUser`:
 * that one reports a failed `me` to the visitor.
 */
export const GuestSessionEffect = () => {
  const { data, loading } = useQuery(GET_ME)
  const isExchanging = useReactiveVar(isPrivyExchangingVar)

  useEnsureGuestSession(!loading && !data?.me && !isExchanging)
  return null
}
